import styled from '@emotion/styled';

export const SubNavWrapper = styled.div`
  max-width: 600px;
  position: relative;
  margin: 20px auto;
`;
